export const FETCH_FORMCATEGORIES = "FETCH_FORMCATEGORIES";
export const FETCH_FORMCATEGORIES_SUCCESS = "FETCH_FORMCATEGORIES_SUCCESS";
export const FETCH_FORMCATEGORIES_FAILURE = "FETCH_FORMCATEGORIES_FAILURE";

export const FETCH_FORMS_BY_CATEGORY = "FETCH_FORMS_BY_CATEGORY";
export const FETCH_FORMS_BY_CATEGORY_SUCCESS = "FETCH_FORMS_BY_CATEGORY_SUCCESS";
export const FETCH_FORMS_BY_CATEGORY_FAILURE = "FETCH_FORMS_BY_CATEGORY_FAILURE";
